"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonV2 = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _styles = require("./styles");

var _material = require("@mui/material");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

var ButtonV2 = function ButtonV2(props) {
  var id = props.id,
      keyId = props.keyId,
      className = props.className,
      disabled = props.disabled,
      type = props.type,
      transparent = props.transparent,
      label = props.label,
      size = props.size,
      borderType = props.borderType,
      icon = props.icon,
      iconPosition = props.iconPosition,
      isLoading = props.isLoading,
      onClick = props.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    id: id,
    className: className,
    type: type,
    transparent: transparent,
    borderType: borderType,
    iconPosition: ["left", "right", "top", "bottom"].includes(iconPosition) ? iconPosition : "left",
    icon: icon,
    label: label,
    size: size,
    disabled: disabled,
    isLoading: isLoading,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      className: "button " + (["white", "whiteS2", "whiteS3", "whiteS4", "pink", "gray", "purple", "purpleS2", "black", "red"].includes(type) ? type : "white") + (transparent ? " transparent" : " fill"),
      variant: "text",
      disabled: disabled || isLoading,
      onClick: /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = onClick;

                  if (!_context.t0) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 4;
                  return onClick(event);

                case 4:
                  _context.t0 = _context.sent;

                case 5:
                  return _context.abrupt("return", _context.t0);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(),
      children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "iconLoading",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
            pulse: true,
            icon: _freeSolidSvgIcons.faSpinner
          })
        }), label && label]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "icon",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
            icon: icon
          })
        }), label && label]
      })
    })
  }, keyId);
};

exports.ButtonV2 = ButtonV2;